module.exports = __webpack_public_path__ + "img/tagWhite.a71dc28c.png";